import { clsx } from 'clsx'
import { type FC, type ReactNode } from 'react'

import { HStack, type HStackProps } from '@/components'

export interface ScreenFooterProps extends HStackProps {
  children: ReactNode
  withSafeBottomMargin?: boolean
}

export const ScreenFooter: FC<ScreenFooterProps> = ({
  className,
  children,
  withSafeBottomMargin = true,
  ...props
}) => (
  <HStack
    className={clsx(
      'gap-1 overflow-hidden rounded-2xl bg-brand-black-500 p-1',
      withSafeBottomMargin && 'mb-safe',
      className
    )}
    {...props}
  >
    {children}
  </HStack>
)
